export default "__VITE_ASSET__BjPIlb6R__"